import React from 'react';

const AccordionContext = React.createContext(null);

export default AccordionContext;
